(ns frontend.zap-time
  (:require
   [common.localization :as loc]
   [common.dates :as d]
   [common.util :as cu]))


(defn now
  []
  (.getTime (js/Date.)))

(defn this-year
  []
  (->> (js/Date.)
       (.getYear)
       (+ 1900)))


(defn long->formatted-date-time
  [ms]
  (-> ms
      js/Date.
      (d/format {:pattern (loc/tr :attachment/date-format)})))

(defn long->formatted-date
  [ms]
  (-> ms
      js/Date.
      (d/format {:pattern (loc/tr :date-format)})))

(def intervals
  [{:interval 1000
    :label    "ms"}
   {:interval 60
    :label    "s"}
   {:interval 60
    :label    "m"}
   {:interval 24
    :label    "h"}
   {:interval 30
    :label    "d"}
   {:interval    12
    :singular-kw :month
    :plural-kw   :months}
   {:interval    1000
    :singular-kw :year
    :plural-kw   :years}
   {:interval    1000000000
    :singular-kw :millenia
    :plural-kw   :millenia}])

(defn long->interval-str
  [ms]
  (let [past? (< ms 0)]
    (loop [t (if past? (- ms) ms)
           prev-str ""
           idx 0]
      (let [meta (get intervals idx)
            interval (:interval meta)
            modulo (mod t interval)
            my-label (str (int modulo)
                          " "
                          (if-let [l (:label meta)]
                            l
                            (loc/tr (if (= modulo 1)
                                  (:singular-kw meta)
                                  (:plural-kw meta)))))]
        (if (> interval t)
          (cu/str-trim-lcase (str my-label
                                  " "
                                  prev-str
                                  (when past?
                                    (str " " (loc/tr :ago)))))
          (recur
           (int (/ t interval))
           (if (= 0 modulo)
             ""
             my-label)
           (inc idx)))))))
